import React from 'react';

const GridDecoration = () => {
    return (
        <div className="relative z-40 h-60">
            <div className="pointer-events-none absolute inset-0 overflow-hidden opacity-50 [perspective:200px]">
                <div className="absolute inset-0 [transform:rotateX(45deg)]">
                    <div className="animate-grid [background-image:linear-gradient(to_right,rgba(255,255,255,0.2)_1px,transparent_0),linear-gradient(to_bottom,rgba(255,255,255,0.2)_1px,transparent_0)] [background-repeat:repeat] [background-size:60px_60px] [height:300vh] [inset:0%_0px] [margin-left:-50%] [transform-origin:100%_0_0] [width:600vw]"></div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-b from-midnight to-transparent to-30%"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-midnight to-transparent to-40%"></div>
                <div className="absolute inset-0 bg-gradient-to-l from-midnight to-transparent to-40%"></div>
                <div className="absolute bottom-0 h-[2px] w-full bg-transparent">
                    <div className="horizon-glow absolute inset-0 h-full w-full"></div>
                </div>
            </div>
        </div>
    );
};

export default GridDecoration;
